import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 70,
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    background: "#fff",
    paddingInline: 28,
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow:
      " 0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08)",
  },
  editIcon: {
    border: `1px solid #ffffff`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#ffffff",
    "& .MuiSvgIcon-root": {
      color: "#000",
      cursor: "pointer",
      fontSize: 20,
    },
    "& .MuiButton-root": {
      color: "#ffffff",
    },
  },
  dispatcherbutton: {
    // background: "#0a0a0aff !important",
    backgroundColor: "#f5f5f5 !important",
    borderColor: "#f5f5f5 !important",
    color: "#000 !important"
  },
  headerleftwrap: {
    display: "flex",
  },
  headerrightwrap: {
    display: "flex",
    justifyContent: "right",
  },
  welcomeContiner: {
    display: "flex",
    alignItems: "center",
    zIndex: 999,
  },
  logo: {
    width: 60,
    height: 60,
    objectFit: "cover",
    cursor: "pointer",
  },
  headernav: {
    paddingTop: "5px",
    paddingBottom: "5px"
  },
  avatarContainer: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  bellnotification: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    margin: "0px 17px"
  },
  menu: {
    top: "20px !important",
    "& .MuiMenu-list": {
      paddingTop: 16,
      paddingBottom: 16,
      background: "#fff",
      backdropFilter: "blur(30px)",
    },
    "& .MuiButtonBase-root": {
      paddingRight: 40,
    },
  },
  menuItem: {
    gap: 8,
  },
  menuLabels: {
    paddingInline: 12,
    dispay: "flex",
    gap: 8,
    alignItems: "center",
  },
}));

export default useStyles;
